import { render, staticRenderFns } from "./DataTableColumnModel.vue?vue&type=template&id=16fff6d2&"
import script from "./DataTableColumnModel.vue?vue&type=script&lang=js&"
export * from "./DataTableColumnModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports